import { render, staticRenderFns } from "./TwilioConference.vue?vue&type=template&id=2d698104&"
import script from "./TwilioConference.vue?vue&type=script&lang=js&"
export * from "./TwilioConference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports